/* ==========================================================================
   cart-recommendations.js
   --------------------------------------------------------------------------
   Hidrata <cart-recommendations>: recomendaciones en el carrito basadas en lo
   que ya esta adentro. Por cada uno de los N productos de mayor valor del
   carrito pide su seccion renderizada (Section Rendering API) con
   intent=complementary (fallback a related), recolecta los .carousel__slide
   (product-card nativo del theme), deduplica, EXCLUYE lo que ya esta en el
   carrito, corta a `limit` e inyecta. Se refresca cuando cambia el carrito.

   Externo a proposito: no depende del bundle de secciones del theme.
   Debug: data-debug="true" en el elemento, o ?cart_rec_debug=1 en la URL.
   ========================================================================== */
(function () {
  'use strict';
  var FORCE_DEBUG = /[?&]cart_rec_debug=1\b/.test(location.search);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  if (customElements.get('cart-recommendations')) return;

  customElements.define('cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.debug = FORCE_DEBUG || this.dataset.debug === 'true';
      this.grid = this.querySelector('.products.carousel');
      this.limit = parseInt(this.dataset.limit || '4', 10);
      this.sourceItems = parseInt(this.dataset.sourceItems || '3', 10);
      this.intent = this.dataset.intent || 'complementary';
      this.fallback = this.dataset.fallback || '';
      this.cache = {};
      this._refresh = debounce(this.refresh.bind(this), 300);
      this.bindCartEvents();
      this.refresh();
    }

    log() { if (this.debug) console.log.apply(console, ['[cart-rec]'].concat([].slice.call(arguments))); }

    async getCart() {
      var r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      return r.json();
    }

    async slidesFor(productId) {
      if (this.cache[productId]) return this.cache[productId];
      var base = this.dataset.urlBase + '?section_id=' + this.dataset.sectionId + '&product_id=' + productId + '&limit=10';
      var slides = await this.fetchSlides(base + '&intent=' + this.intent);
      if (!slides.length && this.fallback) {
        this.log('sin', this.intent, 'para', productId, '- fallback', this.fallback);
        slides = await this.fetchSlides(base + '&intent=' + this.fallback);
      }
      this.cache[productId] = slides;
      return slides;
    }

    async fetchSlides(url) {
      try {
        var res = await fetch(url);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        return [].slice.call(doc.querySelectorAll('.carousel__slide'));
      } catch (e) { console.error('[cart-rec]', e); return []; }
    }

    async refresh() {
      try {
        var cart = await this.getCart();
        if (!cart.items || !cart.items.length) { this.log('carrito vacio'); this._sig = ''; return this.hide(); }

        // Firma del carrito: evita reprocesar (y evita loop cuando el observer
        // detecta nuestra propia inyeccion dentro del drawer).
        var sig = cart.items.map(function (i) { return i.product_id + ':' + i.quantity; }).join(',');
        if (sig === this._sig) { this.log('carrito sin cambios, no recalculo'); return; }
        this._sig = sig;

        var inCart = new Set(cart.items.map(function (i) { return i.product_id; }));
        var source = cart.items.slice().sort(function (a, b) { return b.line_price - a.line_price; }).slice(0, this.sourceItems);
        this.log('items fuente:', source.map(function (i) { return i.product_id; }));

        var seen = new Set(), merged = [];
        for (var s = 0; s < source.length && merged.length < this.limit; s++) {
          var slides = await this.slidesFor(source[s].product_id);
          for (var k = 0; k < slides.length; k++) {
            var slide = slides[k];
            var pid = parseInt(slide.getAttribute('data-product-id') || '0', 10);
            var key = pid || slide.getAttribute('data-product-handle');
            if (inCart.has(pid)) continue;      // ya esta en el carrito
            if (seen.has(key)) continue;        // duplicado
            seen.add(key); merged.push(slide);
            if (merged.length >= this.limit) break;
          }
        }

        if (!merged.length) { this.log('sin recomendaciones tras filtrar'); return this.hide(); }
        this.grid.innerHTML = '';
        merged.forEach(function (n) { this.grid.appendChild(n.cloneNode(true)); }, this);
        this.show();
        this.afterRender();
        this.log('LISTO - pintadas', merged.length);
      } catch (e) { console.error('[cart-rec]', e); }
    }

    show() { this.hidden = false; }
    hide() { this.hidden = true; }

    afterRender() {
      // Empujon para lazy-load (lazysizes u otros observan el DOM, pero por si acaso):
      this.querySelectorAll('img[data-src], img[data-srcset]').forEach(function (img) {
        if (img.dataset.src && !img.src) img.src = img.dataset.src;
        if (img.dataset.srcset && !img.srcset) img.srcset = img.dataset.srcset;
        img.classList.add('lazyloaded');
      });
      // Aviso generico por si el theme reinicializa carruseles/scroll con esto:
      document.dispatchEvent(new CustomEvent('cart-recommendations:rendered', { detail: { el: this } }));
    }

    bindCartEvents() {
      var self = this;
      // 1) Eventos comunes que disparan varios themes al actualizar el carrito
      ['cart:updated', 'cart:refresh', 'cart:build', 'on:cart:update', 'ajaxProduct:added', 'product:added', 'cart:change']
        .forEach(function (ev) { document.addEventListener(ev, self._refresh); });

      // 2) Interceptar fetch a endpoints de carrito (add/change/update/clear)
      if (window.fetch && !window.__cartRecFetchPatched) {
        window.__cartRecFetchPatched = true;
        var of = window.fetch;
        window.fetch = function () {
          var url = arguments[0];
          var u = (typeof url === 'string') ? url : (url && url.url) || '';
          var p = of.apply(this, arguments);
          if (/\/cart\/(add|change|update|clear)/.test(u)) {
            p.then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); });
          }
          return p;
        };
      }

      // 3) Observar el cart drawer por si el theme lo re-renderiza sin evento
      var drawer = document.getElementById('Cart-Drawer') || document.querySelector('cart-drawer, .cart-drawer');
      if (drawer) new MutationObserver(this._refresh).observe(drawer, { childList: true, subtree: true });
    }
  });
})();